import { collection, getDocs, getFirestore } from 'firebase/firestore';
import { getApp } from 'firebase/app';
import { DBCollection } from '@/lib/utils/constants-shared';

/**
 * Fetch all historical events by book data from Firestore
 */
export async function fetchHistoricalEventsByBookFromDB(): Promise<HistoricalEventsByBook[]> {
  const db = getFirestore(getApp());
  const historicalEventsByBookCollection = collection(db, DBCollection.historicalEventsByBook);
  const snapshot = await getDocs(historicalEventsByBookCollection);

  return snapshot.docs.map(doc => {
    const data = doc.data() as FirebaseHistoricalEventsByBook<any>;
    return {
      ...data,
      dateCreated: data.dateCreated.toDate(),
      dateUpdated: data.dateUpdated.toDate()
    } as HistoricalEventsByBook;
  });
}

